/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   h2[_ngcontent-%COMP%]{display:flex;align-items:center}[_nghost-%COMP%]   .wrapper[_ngcontent-%COMP%]{flex:auto;position:relative}[_nghost-%COMP%]   .content[_ngcontent-%COMP%]{position:absolute;left:0;top:0;right:0;bottom:0;overflow:auto}"];
export { styles as styles };
